<template>
  <v-footer
    color="secondary"
    app
  >
    <v-card
      class="flex"
      flat
      tile
      color="secondary"
    >
      <v-card-text class="py-2 primary--text text-center">
        &copy; {{ new Date().getFullYear() }}
        <strong><a href="https://www.youniversal.com/" target="_blank" title="YOUniversal" class="primary--text">YOUniversal</a></strong> —
        Keywords Picker {{ api_version }} — <a href="/horizon" target="_blank"><strong>HORIZON</strong></a>
      </v-card-text>
    </v-card>
  </v-footer>
</template>

<script>
import { mapGetters } from 'vuex'

export default {

    name: 'Admin_Structure_Footer',

    data: () => ({
    }),

    computed: {
        ...mapGetters('config', ['api_version'])
    }
}
</script>
